import type { MLSStaffMenuOptionsType } from 'components/SideMenu/MenuSection/types';

export const isMenuType = (menu: string): menu is MLSStaffMenuOptionsType =>
  ['users', 'brokerages', 'lockboxes'].includes(menu);

export type TableSortType =
  | {
      field?: string;
      direction?: 'asc' | 'desc';
    }
  | undefined
  | null;
